export function resolveAppliedTheme(stamp, themes, modified = null) {
  if (!stamp) {
    return { applied: false, name: null, createdAt: null, appliedAt: null, scope: null, deleted: false, modified: false };
  }

  const loaded = Array.isArray(themes);
  const live = loaded ? themes.find((theme) => theme.id === stamp.themeId) : undefined;
  const deleted = loaded && !live;

  return {
    applied: true,
    name: live?.name ?? stamp.themeName ?? null,
    createdAt: stamp.themeCreatedAt ?? null,
    appliedAt: stamp.appliedAt ?? null,
    scope: stamp.themeScope ?? null,
    deleted,
    modified: deleted ? false : modified,
  };
}

export const isSystemTheme = (theme) => theme?.organization === null || theme?.organization === undefined;

const byName = (a, b) => a.name.localeCompare(b.name, 'sv');
const byNewest = (a, b) => String(b.createdAt ?? '').localeCompare(String(a.createdAt ?? ''));

export function sortThemes(themes, tab, direction) {
  const descending = direction === 'desc';
  const flip = (compare) => (descending ? compare : (a, b) => compare(b, a));
  const byType = (a, b) => (isSystemTheme(a) ? 0 : 1) - (isSystemTheme(b) ? 0 : 1);

  const comparators = {
    created: (a, b) => flip(byNewest)(a, b) || byName(a, b),
    name: (a, b) => flip((x, y) => byName(y, x))(a, b) || byNewest(a, b),
    type: (a, b) => flip(byType)(a, b) || byNewest(a, b) || byName(a, b),
  };

  return [...themes].sort(comparators[tab] ?? comparators.created);
}

export function themeApplyQuestions(diff) {
  const newClasses = diff?.newClasses?.length ?? 0;
  const conflicts = diff?.conflicts?.length ?? 0;
  const builtinSlots = diff?.themeBuiltinSlots?.length ?? 0;
  const ownClasses = newClasses + conflicts;

  return {
    askApplyScope: ownClasses > 0 || builtinSlots > 0,
    askConflicts: conflicts > 0,
    noteNoConflicts: conflicts === 0 && newClasses > 0,
    noteNoThemeClasses: ownClasses === 0,
    noteFonts: (diff?.missingFonts?.length ?? 0) > 0,
    noteDraft: Boolean(diff?.hasPendingDraft),
  };
}
